import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// export async function formatExcelIntervaloApontamentos(registros, dataInicial, dataFinal) {

//     const agrupados = {};

//     registros.forEach(registro => {
//         const { data, nome, chapa, inadimplente, localizacao } = registro;
//         const dataComDia = obterDiaSemana(data);

//         if (!agrupados[nome]) {
//             agrupados[nome] = {
//                 NOME: nome,
//                 CHAPA: chapa,
//                 LOCALIZAÇÕES: new Set(), // Usamos um Set para evitar duplicatas
//             };
//         }

//         agrupados[nome][dataComDia] = inadimplente ? "" : "Aplicativo";
//         agrupados[nome].LOCALIZAÇÕES.add(localizacao);
//     });

//     // Convertendo LOCALIZAÇÕES para string formatada
//     return (Object.values(agrupados).map(item => ({
//         ...item,
//         LOCALIZAÇÕES: Array.from(item.LOCALIZAÇÕES).join(", "),
//     })));

//     // for (const registro of registros) {
//     //     data.push({
//     //         DATA: formatarData(registro.data),
//     //         NOME: registro.nome,
//     //         CHAPA: registro.chapa,
//     //         FEITO: registro.inadimplente ? "Não" : "Sim",
//     //         LOCALIZAÇÕES: registro.localizacao.join(', '),
//     //     });
//     // }

//     // return data;
// }

export async function exportToExcel(data, fileName) {
    // 1. Cria uma nova planilha a partir dos dados
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 2. Cria um novo workbook (arquivo Excel)
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // 3. Converte o workbook em um arquivo binário
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // 4. Salva o arquivo usando FileSaver
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, `${fileName}.xlsx`);
};